import script from "./survey.vue?vue&type=script&setup=true&lang=js"
export * from "./survey.vue?vue&type=script&setup=true&lang=js"

import "./survey.vue?vue&type=style&index=0&id=fda6e94e&scoped=true&lang=scss"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fda6e94e"]])

export default __exports__